import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {AdService} from '@services/ad.service';

@Component({
    selector: 'app-edit-carac',
    templateUrl: './edit-carac.component.html',
    styleUrls: ['./edit-carac.component.scss']
})
export class EditCaracComponent {

    favorite: Favorite;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public adService: AdService,
        public dialogRef: MatDialogRef<EditCaracComponent>) {
        this.favorite = Object.assign({}, data.favorite);
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        this.favorite = this.adService.updateValues(this.favorite);
        this.dialogRef.close(this.favorite);
    }
}
